import Vue from 'vue'
import Vuex from 'vuex'
import { Auth } from 'aws-amplify';

Vue.use(Vuex)
const refreshSession = function(commit){
    let lastAuthUserStorageKey = `CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_userPoolWebClientId}.LastAuthUser`;
    //** console.log('lastAuthUserStorageKey')
    //** console.log(lastAuthUserStorageKey)

    if (lastAuthUserStorageKey != null) {
        let lastAuthUserId = localStorage.getItem(lastAuthUserStorageKey)
        let accessTokenStorageKey = `CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_userPoolWebClientId}.${lastAuthUserId}.accessToken`;
        //** console.log('accessTokenStorageKey')
        //** console.log(accessTokenStorageKey)
        if (accessTokenStorageKey != null) {
            let accessToken = localStorage.getItem(accessTokenStorageKey)
            //** console.log('accessToken')
            //** console.log(accessToken)

            let isSignedIn = accessToken != null
            //** console.log('isSignedIn:' + isSignedIn)
            commit('setIsSignedIn', isSignedIn);
            return;
        }
    }

    commit('setIsSignedIn', false);
}
const set = property => (store, payload) => (store[property] = payload)
const store = new Vuex.Store({
    strict: false,
    state: {
        locale: '',
        isLoading: false,
        isReady: false,
        isSignedIn: false,
        userName: '',
        userProfile: null,
    },

    mutations: {
        setIsReady: set('isReady'),
        setIsLoading: set('isLoading'),
        setIsSignedIn: set('isSignedIn'),
        setLocale(state, value) {
            state.locale = value
            localStorage.setItem('locale', state.locale)
                //EventBus.$emit('APP.Locale.changed', state.locale)
        },
        shiftLocale(state) {
            state.locale = state.locale === 'es-MX' ? 'en' : 'es-MX'
            localStorage.setItem('locale', state.locale)
        },
        setUserName(state){
            state.userName = "jajaja"
            localStorage.setItem('userName', state.userName)
        },
        /**
         *
         * @param {Object} state STATE del módulo
         * @param {Object} payload Datos de la sesión del usuario
         */
        session(state, payload) {
            if (payload.userProfile && payload.userProfile != "") {
                if (payload.userProfile instanceof Object) {
                    state.userProfile = payload.userProfile;
                } else {
                    state.userProfile = JSON.parse(payload.userProfile);
                }
                sessionStorage.setItem(
                    "userProfile",
                    JSON.stringify(state.userProfile)
                );
            } else {
                sessionStorage.removeItem("userProfile");
            }
        },
    },

    getters: {
        locale: (state) => { return state.locale },
        isLoading: (state) => { return state.isLoading },
        isSignedIn: (state) => { return state.isSignedIn },
        userName: (state) => { return state.userName },
        roles: (state) => {
            let roles = state.userProfile ? state.userProfile.userProfiles.map(profile => {
                return profile.profileId;
            }) : [];
            return roles;
          },
    },

    
    actions: {
        init({ dispatch, commit }) {
            let locale = localStorage.getItem('locale')
            locale = (locale && locale !== '') ? locale : 'es-MX'
            commit('setLocale', locale)

            // Obtenemos el userProfile y token del STORE local
            var userProfile = sessionStorage.getItem("userProfile");

            // Almacenamos el profile en el STATE a través de la mutación correspondiente
            commit("session", { userProfile });

            return dispatch('updateSession')
        },
        setLocale({ commit }, locale) {
            commit('setLocale', locale)
        },
        shiftLocale({ commit }) {
            commit('shiftLocale')
        },
        initLoader({ commit }) {
            commit('setIsLoading', true)
        },
        stopLoader({ commit }) {
            commit('setIsLoading', false)
        },
        signOut({ commit }){
            Auth.signOut().then(()=>{
                refreshSession(commit)
            })
        },
        updateSession({ commit }) {
            refreshSession(commit)
        },
        setUserName({ commit }) {
            commit('setUserName')
        },
        setUserProfile({commit}, data) {
            commit('session', data)
        }
    }
})

export default store